import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ProductTypeClient, ProductTypeView, SearchProductTypesParameters } from './api-proxies';
import { CustomizableEntityService } from './customizable-entity-service';
import { ISearchCustomInfoEntityParameters } from './search-custom-info-entity-parameters';

@Injectable({
    providedIn: 'root'
})
export class ProductTypeService extends CustomizableEntityService {
    constructor(private readonly client: ProductTypeClient) {
        super();
    }

    async search(parameters: ISearchCustomInfoEntityParameters): Promise<ProductTypeView[]> {
        return await lastValueFrom(
            this.client.productTypeSearchProductTypes(parameters as SearchProductTypesParameters)
        );
    }

    async getById(id: number): Promise<ProductTypeView> {
        return await lastValueFrom(this.client.productTypeGetById(id));
    }

    async getByIds(ids: number[]): Promise<ProductTypeView[]> {
        return await lastValueFrom(this.client.productTypeGetByIds(ids));
    }

    async save(body: ProductTypeView[]): Promise<ProductTypeView[]> {
        return await lastValueFrom(this.client.productTypeSave(body));
    }

    async activate(id: number): Promise<void> {
        return await lastValueFrom(this.client.productTypeActivate(id));
    }

    async deactivate(id: number): Promise<void> {
        return await lastValueFrom(this.client.productTypeDeactivate(id));
    }
}
